import { punchCardKey } from '.';
import { createPunchCardRowDriver } from './punch-card-row/driver';
export var createPunchCardDriver = function (wrapper) {
    var base = wrapper.$("." + punchCardKey);
    return {
        scaleAmountsAtIdx: function (idx) { return createPunchCardRowDriver(base, idx).scaleAmounts(); },
        rowLabels: function () { return base.$$('.punch-card-row .row-label').text(); },
        tickLabels: function () { return base.$$('.axis-label').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map